<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="tableWrap" style="padding: 40px;">
        <div style="display: flex;align-items: center;margin-bottom: 35px;">
          <div
            style="height: 20px;width:2px; background-color: #6c3dea;margin-right: 15px;"
          ></div>
          <div class="order_title">
            {{ $route.query.type == "edit" ? "編輯問答" : "新增問答" }}
          </div>
        </div>
        <div v-for="(item, index) in promptList" :key="index">
          <div class="common_flex">
            <div class="order_title">問題：</div>
            <textarea
              type="textarea"
              placeholder="请输入問題"
              v-model="item.questionCn"
              maxlength="200"
              class="chart_input"
              v-if="orderlanguageType == 'cn'"
            />
            <textarea
              v-model="item.questionTw"
              type="textarea"
              class="chart_input"
              placeholder="请输入問題"
              maxlength="200"
              v-if="orderlanguageType == 'tw'"
            />
            <textarea
              v-model="item.questionEn"
              type="textarea"
              class="chart_input"
              placeholder="请输入問題"
              maxlength="200"
              v-if="orderlanguageType == 'en'"
            />
           <div style="margin-left: 15px;">
             <div
              v-for="(items, indexs) in newslanguageList"
              :key="indexs"
              @click="changeLanguageorder(items.type)"
              :class="indexs == 1 ? 'lglabel lbnone' : 'lglabel'"
              :style="{
                background: orderlanguageType == items.type ? '#6C3DEA' : '',
                color: orderlanguageType == items.type ? '#fff' : '#6C3DEA',
                display: 'inline-block'
              }"
            >
              {{ items.label }}
            </div>
           </div>
          </div>
          <div style="margin-top: 10px;" class="common_flex">
            <div class="order_title">回答：</div>
            <Editor
              class="editor"
              style="color:#fff;"
              @listenContent="getContent"
              :colorFlag="true"
              :content="item.answerCn"
              :newsFlag="true"
              v-if="orderlanguageType == 'cn'"
              id="contentId"
            ></Editor>
            <Editor
              class="editor"
              style="color:#fff;"
              @listenContent="getContent"
              :colorFlag="true"
              :content="item.answerTw"
              v-if="orderlanguageType == 'tw'"
              :newsFlag="true"
              id="contentId"
            ></Editor>
            <Editor
              class="editor"
              style="color:#fff;"
              @listenContent="getContent"
              :colorFlag="true"
              :content="item.answerEn"
              v-if="orderlanguageType == 'en'"
              :newsFlag="true"
              id="contentId"
            ></Editor>
          </div>
        </div>
        <div class="common_flex" style="margin-top: 10px;">
          <div class="order_title">類別：</div>
          <el-select v-model="questionTypeId" placeholder="請選擇問題類別">
            <el-option
              v-for="item in titleList"
              :key="item.id"
              :value="item.id"
              :label="item.typeTw"
            ></el-option>
          </el-select>
        </div>
        <div style="display: flex;justify-content: center;margin-top: 100px;">
          <div class="button" @click="$router.go(-1)">
            取消
          </div>
          <div
            class="button"
            v-throttle="{
              fn: () => {
                getSumbit();
              },
              time: 2000
            }"
            style="margin-left: 20px;background: #6c3dea;color: #FFFFFF;"
          >
            發佈
          </div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import Editor from "@/components/editor";
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "相關問題 / 問題列表 ",
      navtitle: "問題詳情",
      type: "",
      dialogVisible: false,
      promptList: [
        {
          answerCn: "",
          answerTw: "",
          answerEn: "",
          questionCn: "",
          questionTw: "",
          questionEn: ""
        }
      ],
      orderlanguageType: "cn",
      titleList: [],
      questionTypeId: "",
      newslanguageList: [
        {
          label: "简",
          type: "cn"
        },
        {
          label: "繁",
          type: "tw"
        },
        {
          label: "EN",
          type: "en"
        }
      ]
    };
  },
  created() {
    this.getTitle();
    if (this.$route.query.type == "edit") {
      this.promptList[0] = JSON.parse(JSON.stringify(this.$route.query.data));
      delete this.promptList[0].questionTypeId;
      this.questionTypeId = this.$route.query.data.questionTypeId;
    }
  },

  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    getTitle() {
      let _this = this;
      _this
        .$get(`/request/common/question/type `, {}, _this.$GLOBAL.jsonConfig)
        .then(res => {
          console.log(res);
          if (res.code === "00000") {
            _this.titleList = res.data;
          }
        });
    },
    changeLanguageorder(type) {
      this.orderlanguageType = type;
    },
    getSumbit() {
      let _this = this;
      if (this.questionTypeId == "") {
        this.$message.error("請選擇問題類別");
        return;
      }
      const params = {
        isValid: 1,
        questionTypeId: _this.questionTypeId,
        ..._this.promptList[0]
      };
      _this.dialogVisible = true;
      _this
        .$post(
          `/request/common/question/detail`,
          params,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.$propMessage(
              _this.$route.query.type == "add" ? "新增成功" : "編輯成功",
              "success",
              function() {
                _this.dialogVisible = false;
                _this.$router.go(-1);
              }
            );
          } else {
            _this.dialogVisible = false;
            this.$message.error(res.message);
          }
        });
    },
    getContent(data) {
      let _this = this;
      if (_this.orderlanguageType == "cn") {
        _this.promptList[0].answerCn = data;
      } else if (_this.orderlanguageType == "tw") {
        _this.promptList[0].answerTw = data;
      } else {
        _this.promptList[0].answerEn = data;
      }
    }
  },
  components: {
    NavBar,
    Editor,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.button {
  width: 100px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid;
  cursor: pointer;
}
.lglabel {
  height: 38px;
  line-height: 38px;
  text-align: center;
  padding: 0 20px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.lbnone {
  border-left-width: 0px;
  border-right-width: 0px;
}
.order_title {
  font-size: 14px;
  color: #000;
  width: 100px;
  text-align: left;
}
.add_de {
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
}
.common_flex {
  display: flex;
}
.chart_input {
  height: 114px;
  width: 300px;
  box-sizing: border-box;
  outline: none;
  padding: 10px;
  resize: none;
  color: #000000;
  font-size: 14px;
  background-color: #e8e6f0;
  border: none;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/question/questionDetails.vue